/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Product breadcrumb mobile treatment.
 * Desktop keeps the full Home > Brand > Series > Product hierarchy.
 * On mobile, the breadcrumb is shown and the Brand level is hidden only when
 * the full four-level product hierarchy is present.
 */
(function () {
  var style = document.createElement('style');
  style.id = 'seo-product-breadcrumb-mobile-styles';
  style.textContent = '@media screen and (max-width: 640px) {' +
    'body.template-product .page__sub-header { display: block !important; }' +
    'body.template-product .breadcrumb__item--seo-mobile-brand { display: none !important; }' +
  '}';
  document.head.appendChild(style);

  function setupMobileProductBreadcrumb() {
    if (!document.body || !document.body.classList.contains('template-product')) {
      return;
    }

    var breadcrumbLists = document.querySelectorAll('.page__sub-header .breadcrumb__list');

    breadcrumbLists.forEach(function (list) {
      var items = Array.prototype.filter.call(list.children, function (child) {
        return child.classList.contains('breadcrumb__item');
      });

      if (items.length === 4) {
        items[1].classList.add('breadcrumb__item--seo-mobile-brand');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupMobileProductBreadcrumb);
  } else {
    setupMobileProductBreadcrumb();
  }
})();

/**
 * Collection breadcrumb hierarchy.
 * Series collection data is resolved server-side from the existing read-only
 * custom.series metafield and real product collection memberships.
 */
(function () {
  function setupCollectionBreadcrumb() {
    if (!document.body || !document.body.classList.contains('template-collection')) {
      return;
    }

    var dataElement = document.getElementById('seo-collection-breadcrumb-data');

    if (!dataElement) {
      return;
    }

    var data;

    try {
      data = JSON.parse(dataElement.textContent);
    } catch (error) {
      return;
    }

    if (!data || typeof data.parentTitle !== 'string' || typeof data.parentUrl !== 'string') {
      return;
    }

    var list = document.querySelector('.page__sub-header .breadcrumb__list');

    if (!list || list.querySelector('.breadcrumb__item--seo-collection-parent')) {
      return;
    }

    var items = Array.prototype.filter.call(list.children, function (child) {
      return child.classList.contains('breadcrumb__item');
    });

    if (items.length < 2) {
      return;
    }

    var currentItem = items[items.length - 1];
    var parentItem = document.createElement('li');
    var parentLink = document.createElement('a');

    parentItem.className = 'breadcrumb__item breadcrumb__item--seo-collection-parent';
    parentLink.className = 'breadcrumb__link link';
    parentLink.href = data.parentUrl;
    parentLink.textContent = data.parentTitle;

    parentItem.appendChild(parentLink);

    var separator = items[0].querySelector('svg');

    if (separator) {
      parentItem.appendChild(document.createTextNode(' '));
      parentItem.appendChild(separator.cloneNode(true));
    }

    list.insertBefore(parentItem, currentItem);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupCollectionBreadcrumb);
  } else {
    setupCollectionBreadcrumb();
  }
})();
